<template>
  <div class="modal fade universal-modal" id="universal-modal" tabindex="-1" role="dialog" v-if="isShowModal">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content" id="universal-modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="close" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div :class="{ 'managed-modal': isManagedContent }">
          <div v-if="image" class="modal-image">
            <img :src="getAssetProxy(image)" />
          </div>
          <h1 id="universal-modal-title" class="modal-title" v-html="title" />
          <div class="modal-body" id="universal-modal-body" v-html="body" />
          <div class="modal-footer" id="universal-modal-footer">
            <div v-if="footer" v-html="footer" />
            <div class="modal-cta" v-if="ctaText">
              <button data-test="modal-cta" class="btn btn-cta" @click="handleCta">{{ ctaText }}</button>
            </div>
            <div v-else>
              <button data-test="modal-close" class="btn btn-cta" @click="close">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useAmplitude } from '@outputinc/o-analytics'
import { useModalStore } from '@/store/ModalStore'
import getAssetProxy from '@/utils/getAssetProxy'

const { track, Events } = useAmplitude()
const modalStore = useModalStore()
const { isShowModal, modal, modalName, ctaUrl } = storeToRefs(modalStore)

const title = computed(() => modal.value.title)
const body = computed(() => modal.value.body)
const ctaText = computed(() => modal.value.ctaText)
const footer = computed(() => modal.value.footer)
const image = computed(() => modal.value.image)

const isManagedContent = computed(() => modal.value.isManagedContent)

const handleCta = () => {
  window.open(ctaUrl.value, '_blank')?.focus()
  track(Events.CHECKOUT_SUBSCRIPTION_MODAL_CLICK, { modal: modalName.value })
}

const close = () => modalStore.toggleDisplay()
</script>

<style lang="scss" scoped>
.modal.universal-modal {
  display: block;
  opacity: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(15px);
  h1.modal-title {
    color: var(--color-text-primary);
    line-height: $fs4;
  }

  div.modal-body {
    color: var(--color-text-primary);
  }

  .modal-image {
    margin: 0 auto;
    padding: 0 $spacer-4;
    flex-shrink: 0;
    border-radius: 8px;
  }

  .modal-cta {
    align-items: center;
    color: var(--gray-gray-600, #222);
    display: flex;
    flex-shrink: 0;
    font-family: Gilroy;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    height: 72px;
    justify-content: center;
    line-height: 22px;
    text-align: center;
    width: 100%;

    button {
      padding: 15px 10px;
    }
  }

  .managed-modal {
    padding-top: $spacer-3;
    text-align: center;
    .modal-title {
      margin: $spacer-4 0 0;
      line-height: 1.2;
    }
    .modal-body {
      padding: $spacer-3 $spacer-3 0;
    }
    .modal-body p {
      margin-top: 1em;
    }
    .modal-footer {
      padding-top: 0;
    }
  }
}
</style>
